const CONVERSATION_SESSION_CACHE_LIMIT = 200;

export const conversationSessionCache = new Map();

export const conversationCacheKey = conversation => {
  const accountId = Number(conversation?.account_id || 0);
  const conversationId = Number(conversation?.id || 0);
  return conversationId ? `${accountId}:${conversationId}` : null;
};

export const rememberConversation = conversation => {
  const cacheKey = conversationCacheKey(conversation);
  if (!cacheKey) return conversation;

  conversationSessionCache.delete(cacheKey);
  conversationSessionCache.set(cacheKey, conversation);

  if (conversationSessionCache.size > CONVERSATION_SESSION_CACHE_LIMIT) {
    const oldestCacheKey = conversationSessionCache.keys().next().value;
    conversationSessionCache.delete(oldestCacheKey);
  }

  return conversation;
};
